module.exports = __webpack_public_path__ + "img/carousel05.8461eb2a.webp";